<h1 class="page-title">Hozzászólások</h1>

<button type="button"
        class="btn btn-outline-secondary clickable"
        (click)="showForm()"
        *ngIf="!showNewCommentForm"
>Hozzászólok!</button>

<section id="new-comment" *ngIf="showNewCommentForm">
  <ngb-alert [dismissible]="false" type="info">
    <span class="fa fa-info-circle"
          style="font-size: 250%;display: block;float: left;margin-right: 15px;"
    ></span>
    <span>
      Biztonsági okokból szükséges, hogy a hozzászólás a következő karaktersorozattal kezdődjön: "kkk " (három k és egy
      szóköz). Ha nem így kezded a hozzászólásod, nem kerül mentésre. Ne aggódj, mentéskor eltávolítjuk! =)
    </span>
  </ngb-alert>
  <form (submit)="save()">
    <div class="form-group">
      <label for="commenter" class="form-control-label">Név:</label>
      <input id="commenter" name="commenter" [(ngModel)]="newComment.commenter" class="form-control"/>
    </div>
    <div class="form-group">
      <label for="text" class="form-control-label">Hozzászólás:</label>
      <textarea id="text" name="text" [(ngModel)]="newComment.text" class="form-control"></textarea>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="pending"><i class="fa fa-check"></i> Hozzászólok!</button>
  </form>
</section>

<section id="comments">
  <div *ngFor="let comment of comments" class="comment">
    <span class="commenter">
      {{ comment.commenter }}
      <span *ngIf="auth.hasAnyRoleOf('admin', 'moderator')" class="float-right">
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeComment(comment)"
        ><i class="fa fa-trash"></i> Törlés</button>
      </span>
    </span>
    <span class="date">{{ comment.created_at }}</span>
    <span class="text">{{ comment.text }}</span>
  </div>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/comment/comment.component.html